// ----------------------------------------------------------------
// <copyright company="Microsoft Corporation">
//     Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Styles from './styles.module.scss';
import { capitalize } from 'lodash';
import clsx from 'clsx';

export default function RenderParentBody(props: any): JSX.Element {
    const { t } = useTranslation();
    const [selectedDevice, setSelectedDevice] = React.useState<any[]>(Array());

    const columnHeaders = [
        {
            fieldName: 'name',
            name: t('name'),
            maxWidth: 280,
            minWidth: 100,
            visible: true,
        },
        {
            fieldName: 'sku',
            name: t('SKU'),
            maxWidth: 280,
            minWidth: 100,
            visible: true,
        },
        {
            fieldName: 'serialNumber',
            name: t('serial_number'),
            maxWidth: 280,
            minWidth: 100,
            visible: true,
        },
    ];

    function onSelectionChange(selectedItems: any) {
        return (event: React.MouseEvent) => {
            if (props.onSelect) {
                if (event.target['checked']) {
                    selectedDevice.push(selectedItems);
                }
                else {
                    const indexOfObject = selectedDevice.findIndex((obj: any) => {
                        return obj.sku === selectedItems.sku;
                    });
                    selectedDevice.splice(indexOfObject, 1);
                }
                setSelectedDevice(selectedDevice);
                props.onSelect(selectedDevice);
            }
        };
    }

    return (
        <div className={clsx('ms-Grid', Styles.grid)}>
            <div className="ms-Grid-row">
                <div className={clsx('ms-sm12', Styles.gridParent)}>
    <table className={Styles.tableNonBordered}>
                        <thead>
                            <tr>
                                {React.Children.toArray(
                                    columnHeaders.map((column: any) => (
                                        <>
                                            <th>
                                                <div style={{ width: column.maxWidth }}>{capitalize(column.name)}</div>
                                            </th>
                                        </>
                                    ))
                                )}
                                <th>
                                    <div style={{ width: 48 }}>{t('select')}</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style={props && props.data && props.data.length > 0 ? { display: 'none' } : { textDecorationColor: 'black' }}>
                                <td className={Styles.tdNoRecordFound}>
                                    {t('no_records_found')}
                                </td>
                            </tr>
                            {React.Children.toArray(
                                props.data && props.data.map((element: any) => (
                                    <tr>
                                        {React.Children.toArray(
                                            columnHeaders.map((column: any) => {
                                                if (column.name === t('name')) {
                                                    return (<>
                                                        <td style={{ width: column.maxWidth }}>
                                                            {element.name}
                                                        </td>
                                                    </>);
                                                }
                                                if (column.name === t('SKU')) {
                                                    return (<>
                                                        <td style={{ width: column.maxWidth }}>
                                                            {element.sku}
                                                        </td>
                                                    </>);
                                                }
                                                if (column.name === t('serial_number')) {
                                                    return (<>
                                                        <td style={{ width: column.maxWidth }}>
                                                            {element.serialNumber}
                                                        </td>
                                                    </>);
                                                }
                                                return <></>;
                                            })
                                        )}
                                        <td style={{ width: 40 }}>
                                            <input type="checkbox" style={{ width: 20, height: 20, verticalAlign: 'middle' }}
                                                id={t('select')} name={t('select')} aria-label={element.name}
                                                onClick={onSelectionChange(element)} />
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
